export interface IAnalyticsEvent {
	category: string;
	name: string;
	label: string;
	value: number;
}

export enum IAnalyticsProvider {
	'googleAnalytics' = 'googleAnalytics',
	'microsoftClarity' = 'microsoftClarity'
}
	
export type IAnalyticsTrackingDict = {
	-readonly [k in keyof typeof IAnalyticsProvider]?: string[];
}